export default __webpack_public_path__ + "static/media/logo01.6dffe0f7.svg";